module.exports = __webpack_public_path__ + "img/challenge-active.81cddb21.svg";